// extracted by mini-css-extract-plugin
export default {"ListItemInfoP":"ListItemInfoP_ListItemInfoP__vFwJh"};